import { createRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { noop } from 'lodash/fp';
import classnames from 'classnames/bind';
import { useHasOverflow } from 'app/lib/hooks';
import { StatusDialog } from 'app/components/composite/StatusDialog';
import { MapSnackbarVariantToDialogType, SnackbarVariant } from './constants';

import * as styles from './Snackbar.css';

const cx = classnames.bind(styles);

export function SnackbarDetailsDialog({ message, variant, onClose = noop }) {
    const { t } = useTranslation();
    const ref = createRef();

    const { hasVerticalOverflow } = useHasOverflow(ref);

    const classes = cx('detailsDialogBody', { hasScrollbar: hasVerticalOverflow });

    return (
        <StatusDialog
            onClose={onClose}
            type={MapSnackbarVariantToDialogType[variant]}
            title={t('components:SnackbarDetailsDialog.title.error')}
            testId="SnackbarDetailsDialog">
            <div className={classes} ref={ref}>
                {message}
            </div>
        </StatusDialog>
    );
}

SnackbarDetailsDialog.propTypes = {
    /**
     * Text we show in the details dialog. Should be the same text as in the notification
     */
    message: PropTypes.string,

    /**
     * Determines if the `Show Details`, which opens a dialog with the full message, is displayed always, never or if the message is truncated
     */
    variant: PropTypes.oneOf(Object.values(SnackbarVariant)).isRequired,

    /**
     * will be called when the dialog is closed
     */
    onClose: PropTypes.func
};
